module.exports = __webpack_public_path__ + "static/Freight-BigLight-10c988e78f32fad9ebe31dff91983eae.woff";